import { ValidationErrorComponent } from 'components/common-form/sidePanel/status/validationErrors/ValidationErrors.status';
import type { QuoteKeys, QuoteKeysPrefix } from 'locales/quoteKeys';
import type { FormRecord } from 'models/formError';

import { connectValidationErrors } from './ValidationErrors.connect';

export const ValidationErrors = connectValidationErrors(
  ValidationErrorComponent<FormRecord, QuoteKeys, QuoteKeysPrefix>,
);
